import {
  ChartMapType,
  FieldsLineChartParams,
  LineChartDialogData,
  UpdateLineChartParams
} from "../types/line-chart-modal.types";
import {defaultRangeData} from "./line-chart-filters-config";
import {defaultRecordsDataRequestQueryParams} from "../../../../models/default-records-data-request-query-params";
import {RecordsDataRequestQueryParams} from "../../../../types/records-table.types";

export const lineChartModalName = 'line-chart';

export const defaultLineChartDialogData: LineChartDialogData = {
  recordsTableData: [],
  fields: [],
  parentUrl: '',
  queryParams: defaultRecordsDataRequestQueryParams
}

export const defaultUpdateLineChartParams: UpdateLineChartParams = {
  selectedProductId: '',
  selectedArticleId: '',
  selectedYear: 0,
  selectedColumns: [],
  columnsSelectData: [],
  rangeData: defaultRangeData
}

export const fieldsLineChart: Array<FieldsLineChartParams> = [
  {
    key: 'totalExpenses',
    value: 'Итого расходов'
  },
  {
    key: 'romi',
    value: 'ROMI (показатель окупаемости затрат на маркетинг)'
  },
  {
    key: 'totalProfitWbAndOz',
    value:'Прибыль суммарно WB + OZ (до налогов и рекламных расходов)'
  },
  {
    key: 'unitProfit',
    value: 'Прибыль на ед.'
  },
  {
    key: 'advertisementOrderCost',
    value: 'Стоимость за 1 заказ рекламы'
  }
];

export const chartPrefixMap: Record<string, ChartMapType> = {
  'day-reports': 'day',
  'week-reports': 'week',
  'month-reports': 'month',
} as const

export const defaultLineChartQueryParams: RecordsDataRequestQueryParams = {
  size: 1000,
  page: 0,
  sort: [ 'id,desc' ]
}

